import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_modules: { message: "idle" },
};

export const retrieve_tenant_modules_Slice = createSlice({
 name: "retrieve_tenant_modules",
 initialState,
 reducers: {
  success_retrieve_tenant_modules: (state, action) => {
   state.retrieve_tenant_modules = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_modules: (state, action) => {
   state.retrieve_tenant_modules = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_modules: (state) => {
   state.retrieve_tenant_modules = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_modules: (state) => {
   state.retrieve_tenant_modules = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_modules, fail_retrieve_tenant_modules, reset_retrieve_tenant_modules, loading_retrieve_tenant_modules } = retrieve_tenant_modules_Slice.actions;

export default retrieve_tenant_modules_Slice.reducer;